import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hiddenColumn: { comment: true },
  checkedRows: {},
  showModal: false,
  selectedFringe: null,
  selectedLinkGroup: null,
  fringeGroups: {},
  isUnlinkAllChecked: false,
  isLinkAllChecked: false,
  hasLinkedRows: false,
};

const detailedViewSlice = createSlice({
  name: 'detailedView',
  initialState,
  reducers: {
    setHiddenColumn(state, action) {
      state.hiddenColumn = action.payload;
    },
    setCheckedRows(state, action) {
      state.checkedRows = action.payload;
    },
    setShowModal(state, action) {
      state.showModal = action.payload;
    },
    setSelectedFringe(state, action) {
      state.selectedFringe = action.payload;
    },
    setSelectedLinkGroup(state, action) {
      state.selectedLinkGroup = action.payload;
    },
    setFringeGroups(state, action) {
      state.fringeGroups = action.payload;
    },
    setIsUnlinkAllChecked(state, action) {
      state.isUnlinkAllChecked = action.payload;
    },
    setIsLinkAllChecked(state, action) {
      state.isLinkAllChecked = action.payload;
    },
    setHasLinkedRows(state, action) {
      state.hasLinkedRows = action.payload;
    },
  },
});

export const {
  setHiddenColumn,
  setCheckedRows,
  setShowModal,
  setSelectedFringe,
  setSelectedLinkGroup,
  setFringeGroups,
  setIsUnlinkAllChecked,
  setIsLinkAllChecked,
  setHasLinkedRows,
} = detailedViewSlice.actions;

export default detailedViewSlice.reducer;
